import { baseEmploymentValidation } from "components/Application/Form/ApplicantEmployment/validation";
import * as Yup from "yup";

const validation = Yup.array().of(baseEmploymentValidation);

export default validation;
